import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitEnquiry = (payload) => api.post("/enquiries", payload).then(r => r.data);

export const createChatSession = () =>
  api.post("/chat/session").then(r => r.data);

export const sendChat = (session_id, session_token, message) =>
  api.post("/chat", { session_id, message }, {
    headers: { "X-Session-Token": session_token },
  }).then(r => r.data);

export const fetchEnquiries = (token, type) =>
  api.get("/enquiries", {
    headers: { "X-Admin-Token": token },
    params: type ? { type } : {},
  }).then(r => r.data);

export const updateEnquiryStatus = (token, id, status) =>
  api.patch(`/enquiries/${id}/status`, null, {
    headers: { "X-Admin-Token": token },
    params: { status },
  }).then(r => r.data);
